"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsomorphicLayoutEffect = void 0;
const react_1 = require("react");
/**
 * Because we use Server Side Rendering, using a useLayoutEffect will emit a warning
 * saying useLayoutEffect does nothing on the server and this will lead to a mismatch between
 * the server and client. Creating a useIsomorphicLayoutEffect resolves this problem.
 *
 * Only use useIsomorphicLayoutEffect when you really need to. For example,
 * when loading the SearchPage we want to scroll to the top so results don't get cut off.
 * If we used `useEffect(() => window.scrollTo(0, 0), [])` the layout would render once
 * and then scroll the window to 0, 0. You might see janky scroll UI. To solve this we can use
 * `useLayoutEffect(() => window.scrollTo(0, 0), [])` which will scroll the window to 0, 0 before
 * the browser paints the first render, thus jank avoided!
 */
exports.useIsomorphicLayoutEffect = typeof window === 'undefined' ? react_1.useEffect : react_1.useLayoutEffect;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlSXNvbW9ycGhpY0xheW91dEVmZmVjdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9nZW5lcmljLXV0aWxpdHkvdXNlSXNvbW9ycGhpY0xheW91dEVmZmVjdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsNERBQTREOzs7QUFFNUQsaUNBQW1EO0FBRW5EOzs7Ozs7Ozs7OztHQVdHO0FBQ1UsUUFBQSx5QkFBeUIsR0FBRyxPQUFPLE1BQU0sS0FBSyxXQUFXLENBQUMsQ0FBQyxDQUFDLGlCQUFTLENBQUMsQ0FBQyxDQUFDLHVCQUFlLENBQUMifQ==